<template>
    <div class="row" v-if="viewSections">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="col-lg-12 mb-4" v-else>
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl">
                        Sites/Clients
                    </div>
                    <div class="buttons--row">
                        <div class="search--block">
                            <button @click="getClientsInfo"
                                    class="search--block-btn"
                                    type="submit">
                                <img src="/img/svg/icons-search.svg" alt="search">
                            </button>
                            <input
                                type="search"
                                v-model="filters.search"
                                class="search--block-txt"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="filter-wrap">
                            <label for="" class="reg-label mr-2">Filter:</label>
                            <div class="form-group form-group-2 mb-0">
                                <select
                                    class="custom-select"
                                    v-model="filters.status"
                                    @change.prevent="getClientsInfo"
                                >
                                    <option value="all">All</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                        </div>
                        <a
                            v-if="creatingClients"
                            href="/master-admin/sites-clients/create"
                            class="btn btn--outline-primary btn--middle"
                        >
                            + Add New</a>
                    </div>
                    <div class="table-holder table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('name')">
                                            Client Name <i id="name" class="fas fa-sort"></i>
                                        </a>
                                    </nobr>
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('city')">
                                            City<i id="city" class="fas fa-sort"></i>
                                        </a>
                                    </nobr>
                                </th>
                                <th>Position</th>
                                <th>Status</th>
                                <th style="width:6.625rem"></th>
                                <th class="text-right">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="client in clients"
                                :key="client.id"
                            >
                                <td>
                                    <a v-if="editingClients"
                                       :href="`/master-admin/sites-clients/${client.id}/profile`"
                                    >
                                        <b>{{ client.name }}</b>
                                    </a>
                                    <p v-else>
                                        <b>{{ client.name }}</b>
                                    </p>
                                </td>
                                <td>{{ client.city }}</td>
                                <td>
                                    <div class="tags-list" v-if="client.positions.length > 0">
                                        <div class="tag-wrap" style="width: 50%">
                                            {{ client.positions[0].title }}
                                        </div>
                                        <a
                                            class="action-link dropdown-toggle"
                                            data-toggle="dropdown"
                                            href="#"
                                        >
                                            <b>{{ client.positions.length }}</b> positions</a>
                                        <div class="dropdown-menu">
                                            <div class="tags-wrap">
                                                <div class="tag-item" v-for="pos in client.positions">
                                                    {{ pos.title }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                        <span
                            :class="{
                            'color--green': client.status === 'active',
                             'color--red': client.status === 'inactive'}">
                            {{ client.status | capitalizeFirst }}
                        </span>
                                </td>
                                <td>
                                    <VueToggles
                                        height="30"
                                        width="120"
                                        font-size="14"
                                        checkedText="Active"
                                        uncheckedText="Deactivated"
                                        checkedBg="#60ad45"
                                        uncheckedBg="#e0e1e2"
                                        :value="client.status === 'active'"
                                        @click="switchStatus(client)"
                                    />
                                </td>
                                <td class="text-right">
                                    <div class="action-block">
                                        <button
                                            v-if="deletingClients"
                                            class="delete-link"
                                            @click="showDeleteModal(client.id)"
                                        >
                                            <img src="/img/svg/on.svg" alt="delete">
                                        </button>

                                        <ActionModal confirm-text="Yes" reject-text="No"
                                                     :modalId="getDeleteModalId(client.id)"
                                                     @confirm="deleteClient(client.id)">
                                            <template #body>
                                                <div class="text-center mb-4">
                                                    <h4>
                                                        Are you sure you want <br> to delete this item?
                                                    </h4>
                                                </div>
                                            </template>
                                        </ActionModal>
                                    </div>
                                </td>
                            </tr>
                            <tr v-show="!clients.length > 0">
                                <div class="box-ttl m-3">No results found</div>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        class="ml-3 mr-3"
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage"/>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import SiteClientsService from "./services/SiteClientsService";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: "SitesClients",
    components: {Pagination, ActionModal,},
    mixins: [ModalHandler, SortDirectionHandler, PaginationHandler],
    props: {
        viewSections: Boolean,
        creatingClients: Boolean,
        editingClients: Boolean,
        deletingClients: Boolean,
    },
    data() {
        return {
            clients: [],
            loading: true,
            filters: {
                search: '',
                status: 'all',
                sortBy: 'name',
                sortDir: 'asc',
                page: 1,
                perPage: 10,
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    mounted() {
        this.getClientsInfo()
        this.delayedSearch = createDebouncedFunction(() => this.getClientsInfo(), 500);
    },

    methods: {
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        getList(filters) {
            this.getClientsInfo(filters)
        },
        async deleteClient(id) {
            this.$showLoadingMessage()
            this.clients = this.clients.filter((client) => client.id !== id)
            try {
                await SiteClientsService.deleteClient(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage('The Site was not deleted. Please try again');
            }
        },
        async getClientsInfo() {
            try {
                const {data: clientsList} = await SiteClientsService.getClientsList(this.filters)
                this.clients = clientsList.data
                this.pagination.current_page = clientsList.current_page
                this.pagination.last_page = clientsList.last_page
                this.loading = false
            } catch (e) {
                console.error()
                this.$showErrorMessage();
            }
        },
        async switchStatus(client) {
            this.$showLoadingMessage()
            try {
                let newStatus = client.status === 'active' ? 'inactive' : 'active';
                await SiteClientsService.updateStatus(client.id);
                client.status = newStatus;
                this.$showSuccessMessage('Status was changed successfully ');
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Status was not changed. Please reload page and try again');
            }
        },
    },

}

</script>

<style scoped>

</style>
